module.exports = __webpack_public_path__ + "static/media/adv4.912e036a.jpg";